<template>
  <section>
    <VueSlickCarousel v-bind="settings">
      <div
        class="carousel-slide"
        v-for="link in product.templates"
        :key="link"
        @click="setActive(link)"
      >
        <img :src="link" :alt="`${product.name} example print`" height="100%" />
      </div>
    </VueSlickCarousel>
    <Zoom v-if="active" :active="active" :product="product" @exitModal="unsetActive" />
  </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import Zoom from "../Products/Zoom";
export default {
  props: ["product"],
  components: {
    VueSlickCarousel,
    Zoom
  },
  data() {
    return {
      active: null,
      settings: {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 5,
        initialSlide: 0,
        focusOnSelect: false
      }
    };
  },
  methods: {
    setActive(link) {
      this.active = link;
    },
    unsetActive() {
      this.active = null;
    }
  }
};
</script>

<style scoped lang="scss">
.products-product {
  margin: 50px 0;
}
.carousel-slide {
  height: 300px;
  cursor: pointer;
  img {
    margin: auto;
    @include shadow();
  }
}
</style>